module.exports = __webpack_public_path__ + "img/credit-cards.af649268.svg";